// src/utils/Big.ts
import Big from "big.js";
import toFormat from "toformat";
Big.strict = true;
var Big_default = toFormat(Big);

// src/utils/Decimal.ts
import Decimal from "decimal.js-light";
import toFormat2 from "toformat";
var Decimal_default = toFormat2(Decimal);

// src/utils/index.ts
import { default as default2 } from "jsbi";
export {
  Big_default as Big,
  Decimal_default as Decimal,
  default2 as JSBI
};
//# sourceMappingURL=index.mjs.map